import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import TitleBar from "../../../partials/content/TitleBar";

function AllPreviewPositionsPageSitePublisher() {
  const params = useParams();
  const pageID = parseInt(params.id);
  const [positions, setPositions] = useState([]);
  const [pageData, setPageData] = useState();
  const [sitePublisherData, setSitePublisherData] = useState();
  useEffect(() => {
    const initDataComponent = async () => {
      await getPageInSitePublisher();
      await getPositionsPageSitePublisher();
      scrollForSeeMessage();
    };
    initDataComponent();
  }, []);

  const scrollForSeeMessage = () => {
    const element = document.querySelector("#select-position-container");
    element.scrollIntoView();
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getPageInSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    const pageData = await sendRequestGetPageInSitePublisher(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    setPageData(pageData);
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetSitePublisherData =
      await sendRequestGetSitePublisherData(pageData.web_site_publisher_id);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setSitePublisherData(resultSendRequestGetSitePublisherData);
  };

  const sendRequestGetPageInSitePublisher = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/demo/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionsPageSitePublisher.data.data;
  };

  const getPositionsPageSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const positionsPageSitePublisher =
      await sendRequestGetPositionsPageSitePublisher(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!positionsPageSitePublisher) {
      return;
    }

    setPositions(positionsPageSitePublisher);
  };

  const sendRequestGetPositionsPageSitePublisher = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/demo/position/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionsPageSitePublisher.data.data;
  };

  const sendRequestGetSitePublisherData = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionsPageSitePublisher.data.data;
  };

  const generateCheckBoxAddPositionTag = (
    position,
    isChecked,
    addPositionToState
  ) => {
    return <></>;
  };

  const generatePositionsPageSitePublisher = () => {
    return (
      <>
        <div className="col-12 pt-2">
          <div className="alert alert-warning ">
            <p>
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p>
                  در تصویر زیر میتوانید جایگاه های تبلیغاتی هایلات را در صفحه
                  مدنظر مشاهده نمایید.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            {positions.map((position, index) => {
              return (
                <>
                  <div
                    key={index}
                    className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
                  >
                    <div className="bg-info">
                      <div className="p-2 d-flex">
                        <div className="align-items-center justify-content-center d-flex flex-grow-1">
                          <span>اطلاعات جایگاه</span>
                          <span className="px-2">-</span>
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(position.id)}
                          </span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          اندازه
                        </div>
                        <div className="py-2 w-50 text-center">
                          <span
                            className="letter-spacing-finance-number"
                            dir="ltr"
                          >
                            {helpersNumbers.toPersianNum(
                              position.size.replace("-", "×")
                            )}
                          </span>
                          <span className="pr-2">پیکسل</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          ظرفیت کل
                        </div>
                        <div className="py-2 w-50 text-center">
                          {helpersNumbers.toPersianNum(position.count)}
                          <span className="pr-2">بنر</span>
                        </div>
                      </div>
                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          سهم شما
                        </div>
                        <div className="py-2 w-50 text-center">
                          {helpersNumbers.toPersianNum(1)}
                          <span className="pr-2">بنر</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          ارزش کل
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.base_price
                              )
                            )}
                          </span>
                          <span className="pr-2">تومان</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          پرداختی شما
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.price
                              )
                            )}
                          </span>

                          <span className="pr-2">تومان</span>
                        </div>
                      </div>

                      <div className="px-2 d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          سهم نمایش
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              Math.floor((1 / position.count) * 100)
                            )}
                          </span>
                          <span className="pr-2">درصد</span>
                        </div>
                      </div>

                      <div dir="ltr" className="p-2 text-center border-top">
                        {position.tag_html_id}
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <div className="form-group pt-2">
          <div>
            <a
              href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.img_name}`}
              target="_blank"
            >
              <img
                className="border border-success img-fluid"
                src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.img_name}`}
              />
            </a>
          </div>
        </div>
      </>
    );
  };

  const generatePageDoseNotHaveAnyPositions = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>این صفحه در حال حاضر هیچ جایگاهی ندارد.</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <TitleBar title={`جایگاه های تبلیغات ${pageData?.title} `} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="container-fluid" id="select-position-container">
                <div className="row">
                  <div className="col-12">
                    <div className="text-left">
                      <Link
                        className="btn btn-primary"
                        to={`/publishers/preview/${pageData?.web_site_publisher_id}/all-page`}
                      >
                        <span>بازگشت</span>
                        <span className="pr-2">
                          <i className="fas fa-arrow-left"></i>
                        </span>
                      </Link>
                    </div>
                  </div>

                  {positions.length !== 0
                    ? generatePositionsPageSitePublisher(positions)
                    : generatePageDoseNotHaveAnyPositions()}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPreviewPositionsPageSitePublisher;
